module.exports = framework_15dc59033feee5dfe95f;